import ModelUpdate from "@/models/ModelUpdate";
import {BillState} from "@/helpers/constants";
import Bill from "@/models/bill/Bill";
import {ValidationRule} from "@/declarations/ValidationRule";
import BillRules from "@/models/bill/BillRules";

export default class BillUpdate extends ModelUpdate<Bill> {

	public state!: BillState;
	public name!: string | null;
	public number!: number | null;
	public billingDate!: string;
	public companyId!: string;
	public isPaid!: boolean;
	public notes!: string | null;

	public customerReference!: string | null;

	protected initializeWithDetailModelData(detailModel: Bill): void {
		this.state = detailModel.state;
		this.name = detailModel.name;
		this.number = detailModel.number;
		this.billingDate = detailModel.billingDate;
		this.companyId = detailModel.company.id;
		this.isPaid = detailModel.isPaid;
		this.notes = detailModel.notes;
		this.customerReference = detailModel.customerReference;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'state':
				return BillRules.stateRules;
			case 'name':
				return BillRules.nameRules;
			case 'number':
				return BillRules.numberRules;
			case 'billingDate':
				return BillRules.billingDateRules;
			case 'companyId':
				return BillRules.companyIdRules;
			case 'isPaid':
				return BillRules.isPaidRules;
			default:
				return [];
		}
	}

}
